import * as React from 'react';
import { useCallback, useEffect, useRef } from 'react';
import { serviceTypeToComponent } from './serviceTypeToComponent';
import * as styles from './Services.css';
import { useServices } from './hooks';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { useScrollTo } from '../../../../../../../hooks';
import { selectDisablePromotionSection } from '../../../../../../../selectors/publishTerms';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

export const Services = () => {
  const { services, selectService, selectedService } = useServices();
  const root = useRef<HTMLDivElement>(null);
  const scrollTo = useScrollTo(root);
  const allowDisablePromotionSection = useSelector(selectDisablePromotionSection);

  const handleSelect = useCallback(
    (serviceType: EServiceId) => {
      selectService(serviceType);
    },
    [selectService],
  );

  useEffect(() => {
    if (selectedService) {
      scrollTo(selectedService.type);
    }
  }, [scrollTo, selectedService]);

  return (
    <div className={classNames(styles.root, allowDisablePromotionSection && styles.disabled)} ref={root}>
      {services.map(service => {
        const Service = serviceTypeToComponent[service.type];

        return <Service {...service} key={service.type} onSelect={handleSelect} />;
      })}
    </div>
  );
};
